import dayjs from 'dayjs';
import uuid from 'react-native-uuid';

import type { InhouseLog, LogParam } from './types';
import { logService } from 'shared/src/api/logService';
import { isApp } from 'shared/src/utils';

class InhouseLogger {
  private buffer: InhouseLog[] = [];
  private maxBufferLength = 30;
  private maxBufferTime = 5000;
  private timeoutId: number | undefined;

  constructor() {
    if (isApp()) {
      return;
    }
    this._scheduleFlush();

    window.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        this.flush();
      }
    });
  }

  public log({ eventName, analytics, ablyOnlyLog = {} }: LogParam) {
    this.buffer.push({
      analytics: {
        ANALYTICS_EVENT_NAME: eventName,
        ...analytics,
      },
      ably_only_log: {
        ...ablyOnlyLog,
      },
      common: {
        log_id: uuid.v4(),
        occurred_at: dayjs().format('YYYY-MM-DDTHH:mm:ss.SSS'),
      },
    });

    if (this.buffer.length < this.maxBufferLength) {
      return;
    }

    this.flush();
  }

  public async flush() {
    if (this?.buffer?.length === 0) {
      return;
    }

    const buffer = this.buffer;
    this.buffer = [];

    clearTimeout(this.timeoutId);

    await logService.postLog({
      clientTime: dayjs().format('YYYY-MM-DDTHH:mm:ss.SSS'),
      events: buffer,
    });

    this._scheduleFlush();
  }

  private _scheduleFlush() {
    this.timeoutId = window.setInterval(() => {
      this.flush();
    }, this.maxBufferTime);
  }
}

export const inhouseLogger = new InhouseLogger();
